import React from 'react';

export default function DataDeletion() {
    return (
        <p>To have your data deleted, please send an email, stating that you want your data deleted, to support@fitfren.com</p>
    );
}